// extracted by mini-css-extract-plugin
module.exports = {"user_dropdown":"UserDropdown_user_dropdown__1_U3o","dropdown_trigger":"UserDropdown_dropdown_trigger__3Bsq-"};